import React from 'react'
import PropTypes from 'prop-types'
import { CreditCard, Range } from './.'
import ReactPlaceholder from 'react-placeholder'
import PointsCashPlaceholder from './PointsCashPlaceholder'

const PointsCashContent = props => (
  <ReactPlaceholder
    ready={!props.isLoading}
    customPlaceholder={<PointsCashPlaceholder />}
  >
    <div className='method-creditcard col-12 mt-1 mb-2'>
      <Range {...props} />
      <CreditCard {...props} />
    </div>
  </ReactPlaceholder>
)

PointsCashContent.propTypes = {
  isLoading: PropTypes.bool
}

export default PointsCashContent



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/PointsCashContent.js